namespace Matrix.Rebalancer {
    export namespace InstructionTaskMapService {
        export const baseUrl = 'Rebalancer/InstructionTaskMap';

        export declare function Create(request: Serenity.SaveRequest<InstructionTaskMapRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<InstructionTaskMapRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<InstructionTaskMapRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<InstructionTaskMapRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/InstructionTaskMap/Create",
            Update = "Rebalancer/InstructionTaskMap/Update",
            Delete = "Rebalancer/InstructionTaskMap/Delete",
            Retrieve = "Rebalancer/InstructionTaskMap/Retrieve",
            List = "Rebalancer/InstructionTaskMap/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>InstructionTaskMapService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
